import React, { useEffect } from "react";
import { Container, Row, Col } from '@themesberg/react-bootstrap';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHome, faPrint } from "@fortawesome/free-solid-svg-icons";
import { Breadcrumb } from '@themesberg/react-bootstrap';

import PrintQueueMonitor from '../../settings/print-queue/PrintQueueMonitor';

export default () => {
  useEffect(() => {
    document.title = "Hàng đợi in"
  }, []);

  return (
    <>
      <div className="d-xl-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
        <div className="d-block mb-4 mb-xl-0">
          <Breadcrumb className="d-none d-md-inline-block" listProps={{ className: "breadcrumb-dark breadcrumb-transparent" }}>
            <Breadcrumb.Item><FontAwesomeIcon icon={faHome} /></Breadcrumb.Item>
            <Breadcrumb.Item>Quản lí thiết bị và nhân viên</Breadcrumb.Item>
            <Breadcrumb.Item active>Hàng đợi in</Breadcrumb.Item>
          </Breadcrumb>
          <h4>Hàng đợi in</h4>
          <p className="mb-0">Theo dõi trạng thái hàng đợi in của hệ thống</p>
        </div>
      </div>

      <Container fluid>
        <Row>
          <Col>
            <PrintQueueMonitor />
          </Col>
        </Row>
      </Container>
    </>
  );
};
